import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';

import Social from './Social';

export const NuxFooter = (): JSX.Element => {
  const { t } = useSharedTranslation (namespaces.caregiver);

  return (
    <div className='container'>
      <div className='lg:float-right lg:text-right mb-6 lg:mb-0'>
        <span className='mr-2 hidden lg:inline'>{t('components.footer.followUs')}</span>
        <Social />
      </div>
      <div className='lg:float-left text-xs'>
        <span>&copy; {t('components.footer.copyright')}</span>
      </div>
    </div>
  );
};
